var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ActionLink',_vm._b({attrs:{"href":`${_vm.$config.API_URL}/event-redirect/live/${_vm.redirectUrl}`,"icon-leading":_vm.hasIcon ? 'video-recorder' : '',"data-test-id":"redirect-link"}},'ActionLink',{ hierarchy: _vm.hierarchy, size: _vm.size },false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }